module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp3_7042.2a61a846.png";